<template>
    <nuxt-link to="/" class="logo" external>
        <LogoMain v-if="useDefaultLogo" />
        <NuxtImg
            v-else-if="logo?.filename"
            :src="logo.filename"
            :title="logo.title"
            :alt="logo.alt"
            provider="storyblok"
            format="webp"
            loading="eager"
            densities="x1"
            preload
        />
    </nuxt-link>
</template>

<script setup lang="ts">
import type { IAssetImage } from '@nuxt-monorepo/ui/types/components/AssetImage';

defineProps<{ logo?: IAssetImage; useDefaultLogo?: boolean }>();
</script>

<style scoped lang="postcss">
.logo {
    @apply h-10 px-4;

    img,
    svg {
        @apply h-full;
    }
}
</style>
